// This file is auto-generated. Do not edit manually.

type DeviceSyncAckSqliteParams = { uuid: string };
export type DeviceSyncAckSqliteResponse = { success: boolean };

type DeviceSyncUpdateLastChangeLogIdParams = {
  lastChangeLogId: string;
  schemaInfo?: Record<string, string>;
  deviceName?: string;
  appVersion?: string;
  frontendVersion?: string;
  frontendSha?: string;
  frontendSequence?: number;
};
export type DeviceSyncUpdateLastChangeLogIdResponse = { success: boolean };

type DeviceSyncCreateDeviceTokenParams = {
  deviceName?: string;
  appVersion?: string;
  frontendVersion?: string;
  frontendSha?: string;
  frontendSequence?: number;
};
export type DeviceSyncCreateDeviceTokenResponse = { id: string; token: string };

type DeviceSyncStartSyncParams = {
  objectPath?: string;
  existingClubIds?: Array<string>;
};
export type DeviceSyncStartSyncResponse = { success: boolean; jobId: string };

type DeviceSyncDeleteDeviceTokenParams = { token: string };
export type DeviceSyncDeleteDeviceTokenResponse = {};

type DeviceSyncLogInWithDeviceTokenParams = { tokenId?: string };
export type DeviceSyncLogInWithDeviceTokenResponse = { accessToken: string };

type DeviceSyncUploadSqliteParams = {
  objectPath?: string;
  compressedData?: string;
};
export type DeviceSyncUploadSqliteResponse = {
  success: boolean;
  jobId: string;
};

type DeviceSyncGenerateSqliteV2Params = {
  tables?: Array<string>;
  historical?: boolean;
};
export type DeviceSyncGenerateSqliteV2Response = {
  success: boolean;
  jobId: string;
};

type DeviceSyncGetDeviceTokenParams = {};
export type DeviceSyncGetDeviceTokenResponse = {
  deviceToken: {
    id: string;
    token: string;
    createdAt: string;
    lastChangeLogId?: string;
    schemaInfo?: Record<string, string>;
    accountId: string;
  };
};

type DeviceSyncChangesParams = { onlyLatest?: boolean };
export type DeviceSyncChangesResponse = {
  total: string;
  changes: Array<
    {
      id: string;
      changed_at: string | null;
      row_id: string;
      table_name: string;
      changed_data?: Record<string, string> | null;
    }
  >;
  latestChangeId: string | null;
};

export type DeviceSyncParams =
  | DeviceSyncAckSqliteParams
  | DeviceSyncUpdateLastChangeLogIdParams
  | DeviceSyncCreateDeviceTokenParams
  | DeviceSyncStartSyncParams
  | DeviceSyncDeleteDeviceTokenParams
  | DeviceSyncLogInWithDeviceTokenParams
  | DeviceSyncUploadSqliteParams
  | DeviceSyncGenerateSqliteV2Params
  | DeviceSyncGetDeviceTokenParams
  | DeviceSyncChangesParams;

type ReportingSessionNewPlayersParams = { sessionId: string };
export type ReportingSessionNewPlayersResponse = {
  clubPlayerIds: Array<string>;
};

type ReportingPlayersPerNightParams = {
  clubId: string;
  startDate: string;
  endDate: string;
};
export type ReportingPlayersPerNightResponse = {
  playersPerNight: Array<
    {
      id: string;
      date: string;
      players_per_night: number;
      new_players_count: number;
    }
  >;
};

type ReportingClubPlayerLastPlayedParams = { clubId: string };
export type ReportingClubPlayerLastPlayedResponse = {
  clubPlayersLastPlayed: Array<
    {
      club_player_id: string;
      nights_played: number;
      date_of_first_night_played: string | null;
      date_of_last_night_played: string;
    }
  >;
};

export type ReportingParams =
  | ReportingSessionNewPlayersParams
  | ReportingPlayersPerNightParams
  | ReportingClubPlayerLastPlayedParams;

type StripeHandlerCheckoutParams = { priceId: string };
export type StripeHandlerCheckoutResponse = { url: string };

type StripeHandlerSessionParams = { sessionId: string };
export type StripeHandlerSessionResponse = {
  status: "subscribed";
  customerId: string | null;
};

type StripeHandlerPortalParams = {};
export type StripeHandlerPortalResponse = { url: string };

type StripeHandlerConfigParams = {};
export type StripeHandlerConfigResponse = {
  publishableKey: string;
  prices: Array<
    {
      id: string;
      currency: string;
      object: "price";
      recurring: {
        interval: string;
        interval_count: number;
        trial_period_days: number | null;
        usage_type: string;
      } | null;
      type: string;
      unit_amount: number | null;
      unit_amount_decimal: string | null;
    }
  >;
};

export type StripeHandlerParams =
  | StripeHandlerCheckoutParams
  | StripeHandlerSessionParams
  | StripeHandlerPortalParams
  | StripeHandlerConfigParams;

type ContactSubmitClubContactParams = {
  clubId: string;
  name: string;
  email: string;
  message: string;
  turnstileToken: string;
};
export type ContactSubmitClubContactResponse = {
  success: boolean;
  id?: string;
  error?: string;
};

type ContactSubmitFundingAppealContactParams = {
  appealId: string;
  name: string;
  email: string;
  message: string;
  turnstileToken: string;
};
export type ContactSubmitFundingAppealContactResponse = {
  success: boolean;
  error?: string;
};

type ContactSubmitContactParams = {
  name: string;
  email: string;
  message: string;
  turnstileToken: string;
};
export type ContactSubmitContactResponse = { success: boolean; id: string };

export type ContactParams =
  | ContactSubmitClubContactParams
  | ContactSubmitFundingAppealContactParams
  | ContactSubmitContactParams;

type GlobalSearchSearchParams = {
  search: string;
  clubId?: string;
  includeFunding?: boolean;
};
export type GlobalSearchSearchResponse = {
  results: Array<
    {
      id: string;
      type: string;
      title: string;
      subtitle: string | null;
      club_id: string;
      club_name: string | null;
      tournament_session_id: string | null;
      match_name: string | null;
      match_email: string | null;
      match_phone: string | null;
    }
  >;
};

export type GlobalSearchParams = GlobalSearchSearchParams;

type ImagesPresignUploadParams = {
  accountId: string;
  relativePath: string;
  contentType: string;
};
export type ImagesPresignUploadResponse = {
  putUrl: string;
  publicUrl: string;
  contentType: string;
};

export type ImagesParams = ImagesPresignUploadParams;

type DocumentsSignDocumentReadParams = {
  clubDocumentId?: string | null;
  clubId?: string | null;
  fileId?: string | null;
};
export type DocumentsSignDocumentReadResponse = {
  url: string;
  expiresIn: number;
};

type DocumentsPresignDocumentUploadParams = {
  accountId: string;
  clubId: string;
  fileId: string;
  contentType: string;
};
export type DocumentsPresignDocumentUploadResponse = {
  putUrl: string;
  fileId: string;
  contentType: string;
};

export type DocumentsParams =
  | DocumentsSignDocumentReadParams
  | DocumentsPresignDocumentUploadParams;

type AkahuStartClubOnboardingParams = {
  clubId: string;
  returnPath?: string;
  flow?: "club_onboarding";
};
export type AkahuStartClubOnboardingResponse = {
  redirectUrl: string;
  authorisationUrl: string;
  authorizationUrl: string;
};

type AkahuConfirmClubAkahuPayeeReceivedParams = { clubId: string };
export type AkahuConfirmClubAkahuPayeeReceivedResponse = {
  connectionId: string;
  payeeVerifiedAt: string;
};

type AkahuRejectClubAkahuPayeeNotReceivedParams = { clubId: string };
export type AkahuRejectClubAkahuPayeeNotReceivedResponse = {
  connectionId: string;
  verificationAttemptId: string;
};

type AkahuSaveClubAkahuManualPayeeParams = {
  clubId: string;
  payeeName: string;
  payeeAccountNumber: string;
};
export type AkahuSaveClubAkahuManualPayeeResponse = {
  connectionId: string;
  status: string;
  source: "manual";
  payeeReady: boolean;
  payeeName: string;
  displayNameMasked: string;
};

type AkahuListSupportedBanksParams = {};
export type AkahuListSupportedBanksResponse = {
  banks: Array<{ name: string; logoUrl: string | null }>;
  source: string;
};

type AkahuGetClubAkahuVerificationStatusParams = {
  clubId: string;
  syncFromProvider?: boolean;
};
export type AkahuGetClubAkahuVerificationStatusResponse = {
  source: string | null;
  payeeReady: boolean;
  payeeVerifiedAt: string | null;
  canConfirm: boolean;
  latestAttempt: {
    id: string;
    status: string;
    providerStatus: string | null;
    amount: number;
    currency: string;
    completedAt: string | null;
    failedAt: string | null;
    failureReason: string | null;
  } | null;
};

type AkahuInitiateClubAkahuVerificationParams = {
  clubId: string;
  returnPath?: string;
};
export type AkahuInitiateClubAkahuVerificationResponse = {
  redirectUrl: string;
  verificationAttemptId: string;
  status: string;
  providerStatus: string | null;
};

export type AkahuParams =
  | AkahuStartClubOnboardingParams
  | AkahuConfirmClubAkahuPayeeReceivedParams
  | AkahuRejectClubAkahuPayeeNotReceivedParams
  | AkahuSaveClubAkahuManualPayeeParams
  | AkahuListSupportedBanksParams
  | AkahuGetClubAkahuVerificationStatusParams
  | AkahuInitiateClubAkahuVerificationParams;

type MfaCancelTotpEnrollmentParams = { factorId?: string };
export type MfaCancelTotpEnrollmentResponse = { ok: true };

type MfaVerifyMfaEmailCodeParams = { code: string };
export type MfaVerifyMfaEmailCodeResponse = { ok: true };

type MfaSendMfaEmailCodeParams = {};
export type MfaSendMfaEmailCodeResponse = { ok: true; expiresAt: string };

type MfaRedeemMfaRecoveryCodeParams = { code: string };
export type MfaRedeemMfaRecoveryCodeResponse = { ok: true };

type MfaDisableTotpParams = { totpCode: string };
export type MfaDisableTotpResponse = { ok: true };

type MfaBeginTotpEnrollmentParams = { friendlyName?: string; issuer?: string };
export type MfaBeginTotpEnrollmentResponse = {
  factorId: string;
  secret: string;
  uri: string;
};

type MfaElevateSessionParams = { totpCode: string };
export type MfaElevateSessionResponse = { ok: true; accessToken?: string };

type MfaIssueMfaRecoveryCodesParams = { totpCode?: string };
export type MfaIssueMfaRecoveryCodesResponse = { codes: Array<string> };

type MfaVerifyTotpEnrollmentParams = { factorId: string; code: string };
export type MfaVerifyTotpEnrollmentResponse = { ok: true };

export type MfaParams =
  | MfaCancelTotpEnrollmentParams
  | MfaVerifyMfaEmailCodeParams
  | MfaSendMfaEmailCodeParams
  | MfaRedeemMfaRecoveryCodeParams
  | MfaDisableTotpParams
  | MfaBeginTotpEnrollmentParams
  | MfaElevateSessionParams
  | MfaIssueMfaRecoveryCodesParams
  | MfaVerifyTotpEnrollmentParams;

type InviteAdminAcceptInviteParams = { jwt: string; userId: string };
export type InviteAdminAcceptInviteResponse = { data: "ok" };

type InviteAdminInviteAdminParams = {
  email: string;
  permissions: Record<
    string,
    {
      view_club?: boolean;
      admin_club?: boolean;
      manage_club?: boolean;
      manage_sessions?: boolean;
      manage_funding?: boolean;
    } | null
  >;
};
export type InviteAdminInviteAdminResponse = {
  data: "ok";
  inviteId: string;
  jwt: string;
};

type InviteAdminRejectInviteParams = { jwt: string };
export type InviteAdminRejectInviteResponse = { data: "ok" };

export type InviteAdminParams =
  | InviteAdminAcceptInviteParams
  | InviteAdminInviteAdminParams
  | InviteAdminRejectInviteParams;

type FeedbackSendFeedbackParams = {
  account_id?: string;
  club_name?: string;
  reply_to_id?: string;
  email?: string;
  message: string;
};
export type FeedbackSendFeedbackResponse = { success: boolean; id: string };

type FeedbackReviewFeedbackParams = { feedback_message_id: string };
export type FeedbackReviewFeedbackResponse = { success: boolean };

export type FeedbackParams =
  | FeedbackSendFeedbackParams
  | FeedbackReviewFeedbackParams;

type PlayerPortalTournamentRegistrationParams = {
  competitionId: string;
  partnerCode?: string;
};
export type PlayerPortalTournamentRegistrationResponse = {
  success: boolean;
  partnerCode?: string;
  tournament_player_id: string;
  tournament_registration_id: string;
};

type PlayerPortalAcceptClubInviteParams = { clubId: string };
export type PlayerPortalAcceptClubInviteResponse = { success: boolean };

type PlayerPortalFinishMatchParams = { matchId: string };
export type PlayerPortalFinishMatchResponse = {
  success: boolean;
  status: string;
  completed_at: string;
};

type PlayerPortalGetPlayerLastPlayedAtParams = {};
export type PlayerPortalGetPlayerLastPlayedAtResponse = {
  lastPlayed: Record<string, string>;
};

type PlayerPortalInitiateTournamentAkahuPaymentParams = {
  tournamentPlayerId: string;
  paymentMethodId: string;
  returnPath?: string;
};
export type PlayerPortalInitiateTournamentAkahuPaymentResponse = {
  redirectUrl: string;
  paymentAttemptId: string;
  status: string;
  providerStatus: string | null;
};

type PlayerPortalGetCompetitionDetailsParams = { competitionId: string };
export type PlayerPortalGetCompetitionDetailsResponse = {
  competition: {
    id: string;
    name: string | null;
    entry_type: string;
    tournament_session_id: string;
    status: string;
  };
  session: {
    id: string;
    name: string;
    portal_slug: string | null;
    starts_at: string | null;
    ends_at: string | null;
    status: string;
    completed_at: string | null;
    is_public: boolean;
  } | null;
  registration: {
    id: string;
    tournament_player_id: string;
    tournament_entry_id: string | null;
    partner_names: Array<string>;
    partner_code: string | null;
    partner_email: string | null;
    status: string;
  };
  player: { id: string; name: string; checked_in_at: string | null };
  match: {
    id: string;
    status: string;
    court_id: number | null;
    started_at: string | null;
    entries: { current: Array<string | null> };
    opposing_entry: { id: string; player_names: Array<string> } | null;
  } | null;
  placement: { place: number; division?: number } | null;
  winners: Array<
    { place: number; names: Array<string>; division?: number; isYou: boolean }
  >;
};

type PlayerPortalSignInWithTokenParams = { token: string };
export type PlayerPortalSignInWithTokenResponse = {
  access_token: string;
  refresh_token: string;
};

type PlayerPortalGetCompetitionHistoricMatchesParams = {
  competitionId: string;
};
export type PlayerPortalGetCompetitionHistoricMatchesResponse = {
  matches: Array<
    {
      id: string;
      round: number;
      match_index: number;
      court_id: number | null;
      started_at: string | null;
      completed_at: string | null;
      entries: {
        current: Array<string | null>;
        winners: Array<string>;
        losers: Array<string>;
        score: Record<string, string>;
      };
      player_entry_id: string | null;
      opposing_entry: { id: string; player_names: Array<string> } | null;
      result: string | null;
      group: string | null;
      division: number | null;
    }
  >;
};

type PlayerPortalUpdatePlayerProfileParams = {
  name?: string;
  email?: string;
  mobile?: string;
};
export type PlayerPortalUpdatePlayerProfileResponse = { success: boolean };

type PlayerPortalGetPlayerCompetitionsParams = {};
export type PlayerPortalGetPlayerCompetitionsResponse = {
  registrations: Array<
    {
      id: string;
      tournament_competition_id: string;
      tournament_player_id: string;
      tournament_entry_id: string | null;
      partner_code: string | null;
      partner_joined: boolean;
      withdrawn_at: string | null;
      created_at: string;
      updated_at: string;
      competition: {
        id: string;
        name: string | null;
        entry_type: string;
        tournament_session_id: string;
        status: string;
      };
      entry: {
        id: string;
        entry_registration_count: number;
        partner_names: Array<string>;
      } | null;
      session: {
        id: string;
        name: string;
        portal_slug: string | null;
        starts_at: string | null;
        ends_at: string | null;
        completed_at: string | null;
        requires_payment: boolean;
        status: string;
      };
      placement: number | null;
      computed_status: string;
    }
  >;
};

type PlayerPortalUpdatePlayerGroupParams = {
  clubPlayerId: string;
  groupId: string;
};
export type PlayerPortalUpdatePlayerGroupResponse = { success: boolean };

type PlayerPortalGetPlayerGamesParams = { clubPlayerId: string };
export type PlayerPortalGetPlayerGamesResponse = {
  games: Array<
    {
      players: Array<{ id: string; name: string; group_id: string }>;
      started_at: string;
      index: number;
    }
  >;
};

type PlayerPortalSendTournamentPartnerInvitationParams = {
  tournamentRegistrationId: string;
  email: string;
};
export type PlayerPortalSendTournamentPartnerInvitationResponse = {
  success: boolean;
};

type PlayerPortalStartMatchParams = { matchId: string };
export type PlayerPortalStartMatchResponse = {
  success: boolean;
  status: string;
  started_at: string | null;
};

type PlayerPortalListAkahuSupportedBanksParams = {};
export type PlayerPortalListAkahuSupportedBanksResponse = {
  banks: Array<{ name: string; logoUrl: string | null }>;
  source: string;
};

type PlayerPortalTournamentPaymentParams = {
  tournamentPlayerId: string;
  paymentMethodId: string | string;
};
export type PlayerPortalTournamentPaymentResponse = {
  success: boolean;
  tournament_player_id: string;
};

type PlayerPortalCheckInPlayerParams = { competitionId: string };
export type PlayerPortalCheckInPlayerResponse = {
  success: boolean;
  checked_in_at: string;
};

type PlayerPortalSendTournamentSignInEmailActionParams = {
  name: string;
  email: string;
  competitionId: string;
  partnerCode?: string;
};
export type PlayerPortalSendTournamentSignInEmailActionResponse = {
  success: boolean;
  action_link?: string;
};

type PlayerPortalGetTournamentPaymentAttemptStatusParams = {
  paymentAttemptId: string;
};
export type PlayerPortalGetTournamentPaymentAttemptStatusResponse = {
  paymentAttemptId: string;
  status: string;
  paidAt: string | null;
};

type PlayerPortalGetClubSessionIntentsParams = {
  clubPlayerId: string;
  clubId: string;
};
export type PlayerPortalGetClubSessionIntentsResponse = {
  intents: Array<
    {
      recurringSessionId: string;
      sessionDate: string | null;
      attending: boolean | null;
      canEdit: boolean;
    }
  >;
};

type PlayerPortalSetSessionIntentParams = {
  clubPlayerId: string;
  recurringSessionId: string;
  attending?: boolean;
  clear?: boolean;
};
export type PlayerPortalSetSessionIntentResponse = {
  success: boolean;
  sessionDate: string | null;
};

type PlayerPortalSwapNotificationJwtParams = { token: string; page?: string };
export type PlayerPortalSwapNotificationJwtResponse = {
  access_token: string;
  refresh_token: string;
  club_id: string;
  club_player_id: string;
};

type PlayerPortalSignInWithNFCParams = { tag: string };
export type PlayerPortalSignInWithNFCResponse = { access_token: string };

type PlayerPortalSendSignInEmailParams = {
  signInWith: { email: string } | { uid: string; redirectTo?: unknown };
};
export type PlayerPortalSendSignInEmailResponse = {
  success: boolean;
  action_link?: string;
};

export type PlayerPortalParams =
  | PlayerPortalTournamentRegistrationParams
  | PlayerPortalAcceptClubInviteParams
  | PlayerPortalFinishMatchParams
  | PlayerPortalGetPlayerLastPlayedAtParams
  | PlayerPortalInitiateTournamentAkahuPaymentParams
  | PlayerPortalGetCompetitionDetailsParams
  | PlayerPortalSignInWithTokenParams
  | PlayerPortalGetCompetitionHistoricMatchesParams
  | PlayerPortalUpdatePlayerProfileParams
  | PlayerPortalGetPlayerCompetitionsParams
  | PlayerPortalUpdatePlayerGroupParams
  | PlayerPortalGetPlayerGamesParams
  | PlayerPortalSendTournamentPartnerInvitationParams
  | PlayerPortalStartMatchParams
  | PlayerPortalListAkahuSupportedBanksParams
  | PlayerPortalTournamentPaymentParams
  | PlayerPortalCheckInPlayerParams
  | PlayerPortalSendTournamentSignInEmailActionParams
  | PlayerPortalGetTournamentPaymentAttemptStatusParams
  | PlayerPortalGetClubSessionIntentsParams
  | PlayerPortalSetSessionIntentParams
  | PlayerPortalSwapNotificationJwtParams
  | PlayerPortalSignInWithNFCParams
  | PlayerPortalSendSignInEmailParams;

type AccountResendEmailChangeCodeParams = {
  requestId: string;
  purpose: string;
};
export type AccountResendEmailChangeCodeResponse = {
  ok: true;
  expiresAt: string;
};

type AccountBeginEmailChangeParams = { newEmail: string };
export type AccountBeginEmailChangeResponse = {
  requestId: string;
  stepUp: string;
  newEmail: string;
  expiresAt: string;
};

type AccountChangePasswordParams = {
  newPassword: string;
  currentPassword?: string;
  totpCode?: string;
};
export type AccountChangePasswordResponse = { ok: true };

type AccountVerifyEmailChangeNewParams = { requestId: string; code: string };
export type AccountVerifyEmailChangeNewResponse = { ok: true; email: string };

type AccountVerifyEmailChangeStepUpParams = {
  requestId: string;
  code?: string;
};
export type AccountVerifyEmailChangeStepUpResponse = {
  ok: true;
  expiresAt: string;
};

export type AccountParams =
  | AccountResendEmailChangeCodeParams
  | AccountBeginEmailChangeParams
  | AccountChangePasswordParams
  | AccountVerifyEmailChangeNewParams
  | AccountVerifyEmailChangeStepUpParams;

type NotificationsCreateClubNotificationParams = {
  clubPlayerIds: Array<string>;
};
export type NotificationsCreateClubNotificationResponse = { success: boolean };

type NotificationsSendTournamentThankYouParams = {
  tournamentSessionId: string;
  thankYouText?: string | null;
};
export type NotificationsSendTournamentThankYouResponse = {
  recipientCount: number;
};

export type NotificationsParams =
  | NotificationsCreateClubNotificationParams
  | NotificationsSendTournamentThankYouParams;

type FundingQueueBulkFundingOutreachEmailParams = {
  outreachIds: Array<string>;
  subject: string;
  bodyHtml: string;
  fundingAppealEmailTemplateId?: string;
};
export type FundingQueueBulkFundingOutreachEmailResponse = {
  success: boolean;
  pendingReview: boolean;
  pendingId: string | null;
  queuedCount: number;
  skippedCount: number;
};

type FundingSendFundingOutreachEmailParams = {
  outreachId: string;
  subject: string;
  bodyHtml: string;
  requireHumanReview?: boolean;
  fundingAppealEmailTemplateId?: string;
};
export type FundingSendFundingOutreachEmailResponse = {
  success: boolean;
  communicationId?: string;
  pendingReview?: boolean;
  pendingId?: string;
};

type FundingSendPendingFundingOutreachEmailParams = { pendingId: string };
export type FundingSendPendingFundingOutreachEmailResponse = {
  success: boolean;
  communicationId?: string;
};

type FundingAnalyzeFundingCommunicationParams = { communicationId: string };
export type FundingAnalyzeFundingCommunicationResponse = {
  sentiment: string;
  summary: string | null;
  amount_cents: number | null;
  raw_response?: string;
};

type FundingStartFunderEnrichmentParams = { funderId: string };
export type FundingStartFunderEnrichmentResponse = { jobId: string };

type FundingStartFundingScoutRunParams = {
  appealId: string;
  excludedLanes?: Array<string>;
  clearExistingSuggestions?: boolean;
};
export type FundingStartFundingScoutRunResponse = {
  runId: string;
  jobId: string;
};

export type FundingParams =
  | FundingQueueBulkFundingOutreachEmailParams
  | FundingSendFundingOutreachEmailParams
  | FundingSendPendingFundingOutreachEmailParams
  | FundingAnalyzeFundingCommunicationParams
  | FundingStartFunderEnrichmentParams
  | FundingStartFundingScoutRunParams;

type SessionAdoptSessionParams = { token: string };
export type SessionAdoptSessionResponse = { accountUserId: string };

type SessionCreateSessionParams = {
  courts: number;
  name?: string;
  recurringSessionId?: string;
  clubId?: string;
};
export type SessionCreateSessionResponse = { id: string };

export type SessionParams =
  | SessionAdoptSessionParams
  | SessionCreateSessionParams;

import { formatEdgeFunctionError } from "@mixitone/util";

async function invokeAction<R>(
  functionName: string,
  actionName: string,
  params: any,
) {
  // @ts-ignore
  const adapter = window.sessionAdapter;
  if (!adapter) throw new Error("Session adapter not found");

  const response = await adapter.edgeFunction(functionName, {
    action: actionName,
    ...params,
  });

  if (response.error) {
    throw new Error(formatEdgeFunctionError(response.error, response.data));
  }
  return response.data as R;
}

export const actions = {
  deviceSync: {
    ackSqlite: (params: DeviceSyncAckSqliteParams) =>
      invokeAction<DeviceSyncAckSqliteResponse>(
        "device-sync",
        "ackSqlite",
        params,
      ),
    updateLastChangeLogId: (params: DeviceSyncUpdateLastChangeLogIdParams) =>
      invokeAction<DeviceSyncUpdateLastChangeLogIdResponse>(
        "device-sync",
        "updateLastChangeLogId",
        params,
      ),
    createDeviceToken: (params: DeviceSyncCreateDeviceTokenParams) =>
      invokeAction<DeviceSyncCreateDeviceTokenResponse>(
        "device-sync",
        "createDeviceToken",
        params,
      ),
    startSync: (params: DeviceSyncStartSyncParams) =>
      invokeAction<DeviceSyncStartSyncResponse>(
        "device-sync",
        "startSync",
        params,
      ),
    deleteDeviceToken: (params: DeviceSyncDeleteDeviceTokenParams) =>
      invokeAction<DeviceSyncDeleteDeviceTokenResponse>(
        "device-sync",
        "deleteDeviceToken",
        params,
      ),
    logInWithDeviceToken: (params: DeviceSyncLogInWithDeviceTokenParams) =>
      invokeAction<DeviceSyncLogInWithDeviceTokenResponse>(
        "device-sync",
        "logInWithDeviceToken",
        params,
      ),
    uploadSqlite: (params: DeviceSyncUploadSqliteParams) =>
      invokeAction<DeviceSyncUploadSqliteResponse>(
        "device-sync",
        "uploadSqlite",
        params,
      ),
    generateSqliteV2: (params: DeviceSyncGenerateSqliteV2Params) =>
      invokeAction<DeviceSyncGenerateSqliteV2Response>(
        "device-sync",
        "generateSqliteV2",
        params,
      ),
    getDeviceToken: (params: DeviceSyncGetDeviceTokenParams) =>
      invokeAction<DeviceSyncGetDeviceTokenResponse>(
        "device-sync",
        "getDeviceToken",
        params,
      ),
    changes: (params: DeviceSyncChangesParams) =>
      invokeAction<DeviceSyncChangesResponse>("device-sync", "changes", params),
  },
  reporting: {
    sessionNewPlayers: (params: ReportingSessionNewPlayersParams) =>
      invokeAction<ReportingSessionNewPlayersResponse>(
        "reporting",
        "session-new-players",
        params,
      ),
    playersPerNight: (params: ReportingPlayersPerNightParams) =>
      invokeAction<ReportingPlayersPerNightResponse>(
        "reporting",
        "players-per-night",
        params,
      ),
    clubPlayerLastPlayed: (params: ReportingClubPlayerLastPlayedParams) =>
      invokeAction<ReportingClubPlayerLastPlayedResponse>(
        "reporting",
        "club-player-last-played",
        params,
      ),
  },
  stripeHandler: {
    checkout: (params: StripeHandlerCheckoutParams) =>
      invokeAction<StripeHandlerCheckoutResponse>(
        "stripe-handler",
        "checkout",
        params,
      ),
    session: (params: StripeHandlerSessionParams) =>
      invokeAction<StripeHandlerSessionResponse>(
        "stripe-handler",
        "session",
        params,
      ),
    portal: (params: StripeHandlerPortalParams) =>
      invokeAction<StripeHandlerPortalResponse>(
        "stripe-handler",
        "portal",
        params,
      ),
    config: (params: StripeHandlerConfigParams) =>
      invokeAction<StripeHandlerConfigResponse>(
        "stripe-handler",
        "config",
        params,
      ),
  },
  contact: {
    submitClubContact: (params: ContactSubmitClubContactParams) =>
      invokeAction<ContactSubmitClubContactResponse>(
        "contact",
        "submitClubContact",
        params,
      ),
    submitFundingAppealContact: (
      params: ContactSubmitFundingAppealContactParams,
    ) =>
      invokeAction<ContactSubmitFundingAppealContactResponse>(
        "contact",
        "submitFundingAppealContact",
        params,
      ),
    submitContact: (params: ContactSubmitContactParams) =>
      invokeAction<ContactSubmitContactResponse>(
        "contact",
        "submitContact",
        params,
      ),
  },
  globalSearch: {
    search: (params: GlobalSearchSearchParams) =>
      invokeAction<GlobalSearchSearchResponse>(
        "global-search",
        "search",
        params,
      ),
  },
  images: {
    presignUpload: (params: ImagesPresignUploadParams) =>
      invokeAction<ImagesPresignUploadResponse>(
        "images",
        "presignUpload",
        params,
      ),
  },
  documents: {
    signDocumentRead: (params: DocumentsSignDocumentReadParams) =>
      invokeAction<DocumentsSignDocumentReadResponse>(
        "documents",
        "signDocumentRead",
        params,
      ),
    presignDocumentUpload: (params: DocumentsPresignDocumentUploadParams) =>
      invokeAction<DocumentsPresignDocumentUploadResponse>(
        "documents",
        "presignDocumentUpload",
        params,
      ),
  },
  akahu: {
    startClubOnboarding: (params: AkahuStartClubOnboardingParams) =>
      invokeAction<AkahuStartClubOnboardingResponse>(
        "akahu",
        "startClubOnboarding",
        params,
      ),
    confirmClubAkahuPayeeReceived: (
      params: AkahuConfirmClubAkahuPayeeReceivedParams,
    ) =>
      invokeAction<AkahuConfirmClubAkahuPayeeReceivedResponse>(
        "akahu",
        "confirmClubAkahuPayeeReceived",
        params,
      ),
    rejectClubAkahuPayeeNotReceived: (
      params: AkahuRejectClubAkahuPayeeNotReceivedParams,
    ) =>
      invokeAction<AkahuRejectClubAkahuPayeeNotReceivedResponse>(
        "akahu",
        "rejectClubAkahuPayeeNotReceived",
        params,
      ),
    saveClubAkahuManualPayee: (params: AkahuSaveClubAkahuManualPayeeParams) =>
      invokeAction<AkahuSaveClubAkahuManualPayeeResponse>(
        "akahu",
        "saveClubAkahuManualPayee",
        params,
      ),
    listSupportedBanks: (params: AkahuListSupportedBanksParams) =>
      invokeAction<AkahuListSupportedBanksResponse>(
        "akahu",
        "listSupportedBanks",
        params,
      ),
    getClubAkahuVerificationStatus: (
      params: AkahuGetClubAkahuVerificationStatusParams,
    ) =>
      invokeAction<AkahuGetClubAkahuVerificationStatusResponse>(
        "akahu",
        "getClubAkahuVerificationStatus",
        params,
      ),
    initiateClubAkahuVerification: (
      params: AkahuInitiateClubAkahuVerificationParams,
    ) =>
      invokeAction<AkahuInitiateClubAkahuVerificationResponse>(
        "akahu",
        "initiateClubAkahuVerification",
        params,
      ),
  },
  mfa: {
    cancelTotpEnrollment: (params: MfaCancelTotpEnrollmentParams) =>
      invokeAction<MfaCancelTotpEnrollmentResponse>(
        "mfa",
        "cancelTotpEnrollment",
        params,
      ),
    verifyMfaEmailCode: (params: MfaVerifyMfaEmailCodeParams) =>
      invokeAction<MfaVerifyMfaEmailCodeResponse>(
        "mfa",
        "verifyMfaEmailCode",
        params,
      ),
    sendMfaEmailCode: (params: MfaSendMfaEmailCodeParams) =>
      invokeAction<MfaSendMfaEmailCodeResponse>(
        "mfa",
        "sendMfaEmailCode",
        params,
      ),
    redeemMfaRecoveryCode: (params: MfaRedeemMfaRecoveryCodeParams) =>
      invokeAction<MfaRedeemMfaRecoveryCodeResponse>(
        "mfa",
        "redeemMfaRecoveryCode",
        params,
      ),
    disableTotp: (params: MfaDisableTotpParams) =>
      invokeAction<MfaDisableTotpResponse>("mfa", "disableTotp", params),
    beginTotpEnrollment: (params: MfaBeginTotpEnrollmentParams) =>
      invokeAction<MfaBeginTotpEnrollmentResponse>(
        "mfa",
        "beginTotpEnrollment",
        params,
      ),
    elevateSession: (params: MfaElevateSessionParams) =>
      invokeAction<MfaElevateSessionResponse>("mfa", "elevateSession", params),
    issueMfaRecoveryCodes: (params: MfaIssueMfaRecoveryCodesParams) =>
      invokeAction<MfaIssueMfaRecoveryCodesResponse>(
        "mfa",
        "issueMfaRecoveryCodes",
        params,
      ),
    verifyTotpEnrollment: (params: MfaVerifyTotpEnrollmentParams) =>
      invokeAction<MfaVerifyTotpEnrollmentResponse>(
        "mfa",
        "verifyTotpEnrollment",
        params,
      ),
  },
  inviteAdmin: {
    acceptInvite: (params: InviteAdminAcceptInviteParams) =>
      invokeAction<InviteAdminAcceptInviteResponse>(
        "invite-admin",
        "acceptInvite",
        params,
      ),
    inviteAdmin: (params: InviteAdminInviteAdminParams) =>
      invokeAction<InviteAdminInviteAdminResponse>(
        "invite-admin",
        "inviteAdmin",
        params,
      ),
    rejectInvite: (params: InviteAdminRejectInviteParams) =>
      invokeAction<InviteAdminRejectInviteResponse>(
        "invite-admin",
        "rejectInvite",
        params,
      ),
  },
  feedback: {
    sendFeedback: (params: FeedbackSendFeedbackParams) =>
      invokeAction<FeedbackSendFeedbackResponse>(
        "feedback",
        "sendFeedback",
        params,
      ),
    reviewFeedback: (params: FeedbackReviewFeedbackParams) =>
      invokeAction<FeedbackReviewFeedbackResponse>(
        "feedback",
        "reviewFeedback",
        params,
      ),
  },
  playerPortal: {
    tournamentRegistration: (
      params: PlayerPortalTournamentRegistrationParams,
    ) =>
      invokeAction<PlayerPortalTournamentRegistrationResponse>(
        "player-portal",
        "tournamentRegistration",
        params,
      ),
    acceptClubInvite: (params: PlayerPortalAcceptClubInviteParams) =>
      invokeAction<PlayerPortalAcceptClubInviteResponse>(
        "player-portal",
        "acceptClubInvite",
        params,
      ),
    finishMatch: (params: PlayerPortalFinishMatchParams) =>
      invokeAction<PlayerPortalFinishMatchResponse>(
        "player-portal",
        "finishMatch",
        params,
      ),
    getPlayerLastPlayedAt: (params: PlayerPortalGetPlayerLastPlayedAtParams) =>
      invokeAction<PlayerPortalGetPlayerLastPlayedAtResponse>(
        "player-portal",
        "getPlayerLastPlayedAt",
        params,
      ),
    initiateTournamentAkahuPayment: (
      params: PlayerPortalInitiateTournamentAkahuPaymentParams,
    ) =>
      invokeAction<PlayerPortalInitiateTournamentAkahuPaymentResponse>(
        "player-portal",
        "initiateTournamentAkahuPayment",
        params,
      ),
    getCompetitionDetails: (params: PlayerPortalGetCompetitionDetailsParams) =>
      invokeAction<PlayerPortalGetCompetitionDetailsResponse>(
        "player-portal",
        "getCompetitionDetails",
        params,
      ),
    signInWithToken: (params: PlayerPortalSignInWithTokenParams) =>
      invokeAction<PlayerPortalSignInWithTokenResponse>(
        "player-portal",
        "signInWithToken",
        params,
      ),
    getCompetitionHistoricMatches: (
      params: PlayerPortalGetCompetitionHistoricMatchesParams,
    ) =>
      invokeAction<PlayerPortalGetCompetitionHistoricMatchesResponse>(
        "player-portal",
        "getCompetitionHistoricMatches",
        params,
      ),
    updatePlayerProfile: (params: PlayerPortalUpdatePlayerProfileParams) =>
      invokeAction<PlayerPortalUpdatePlayerProfileResponse>(
        "player-portal",
        "updatePlayerProfile",
        params,
      ),
    getPlayerCompetitions: (params: PlayerPortalGetPlayerCompetitionsParams) =>
      invokeAction<PlayerPortalGetPlayerCompetitionsResponse>(
        "player-portal",
        "getPlayerCompetitions",
        params,
      ),
    updatePlayerGroup: (params: PlayerPortalUpdatePlayerGroupParams) =>
      invokeAction<PlayerPortalUpdatePlayerGroupResponse>(
        "player-portal",
        "updatePlayerGroup",
        params,
      ),
    getPlayerGames: (params: PlayerPortalGetPlayerGamesParams) =>
      invokeAction<PlayerPortalGetPlayerGamesResponse>(
        "player-portal",
        "getPlayerGames",
        params,
      ),
    sendTournamentPartnerInvitation: (
      params: PlayerPortalSendTournamentPartnerInvitationParams,
    ) =>
      invokeAction<PlayerPortalSendTournamentPartnerInvitationResponse>(
        "player-portal",
        "sendTournamentPartnerInvitation",
        params,
      ),
    startMatch: (params: PlayerPortalStartMatchParams) =>
      invokeAction<PlayerPortalStartMatchResponse>(
        "player-portal",
        "startMatch",
        params,
      ),
    listAkahuSupportedBanks: (
      params: PlayerPortalListAkahuSupportedBanksParams,
    ) =>
      invokeAction<PlayerPortalListAkahuSupportedBanksResponse>(
        "player-portal",
        "listAkahuSupportedBanks",
        params,
      ),
    tournamentPayment: (params: PlayerPortalTournamentPaymentParams) =>
      invokeAction<PlayerPortalTournamentPaymentResponse>(
        "player-portal",
        "tournamentPayment",
        params,
      ),
    checkInPlayer: (params: PlayerPortalCheckInPlayerParams) =>
      invokeAction<PlayerPortalCheckInPlayerResponse>(
        "player-portal",
        "checkInPlayer",
        params,
      ),
    sendTournamentSignInEmailAction: (
      params: PlayerPortalSendTournamentSignInEmailActionParams,
    ) =>
      invokeAction<PlayerPortalSendTournamentSignInEmailActionResponse>(
        "player-portal",
        "sendTournamentSignInEmailAction",
        params,
      ),
    getTournamentPaymentAttemptStatus: (
      params: PlayerPortalGetTournamentPaymentAttemptStatusParams,
    ) =>
      invokeAction<PlayerPortalGetTournamentPaymentAttemptStatusResponse>(
        "player-portal",
        "getTournamentPaymentAttemptStatus",
        params,
      ),
    getClubSessionIntents: (params: PlayerPortalGetClubSessionIntentsParams) =>
      invokeAction<PlayerPortalGetClubSessionIntentsResponse>(
        "player-portal",
        "getClubSessionIntents",
        params,
      ),
    setSessionIntent: (params: PlayerPortalSetSessionIntentParams) =>
      invokeAction<PlayerPortalSetSessionIntentResponse>(
        "player-portal",
        "setSessionIntent",
        params,
      ),
    swapNotificationJwt: (params: PlayerPortalSwapNotificationJwtParams) =>
      invokeAction<PlayerPortalSwapNotificationJwtResponse>(
        "player-portal",
        "swapNotificationJwt",
        params,
      ),
    signInWithNFC: (params: PlayerPortalSignInWithNFCParams) =>
      invokeAction<PlayerPortalSignInWithNFCResponse>(
        "player-portal",
        "signInWithNFC",
        params,
      ),
    sendSignInEmail: (params: PlayerPortalSendSignInEmailParams) =>
      invokeAction<PlayerPortalSendSignInEmailResponse>(
        "player-portal",
        "sendSignInEmail",
        params,
      ),
  },
  account: {
    resendEmailChangeCode: (params: AccountResendEmailChangeCodeParams) =>
      invokeAction<AccountResendEmailChangeCodeResponse>(
        "account",
        "resendEmailChangeCode",
        params,
      ),
    beginEmailChange: (params: AccountBeginEmailChangeParams) =>
      invokeAction<AccountBeginEmailChangeResponse>(
        "account",
        "beginEmailChange",
        params,
      ),
    changePassword: (params: AccountChangePasswordParams) =>
      invokeAction<AccountChangePasswordResponse>(
        "account",
        "changePassword",
        params,
      ),
    verifyEmailChangeNew: (params: AccountVerifyEmailChangeNewParams) =>
      invokeAction<AccountVerifyEmailChangeNewResponse>(
        "account",
        "verifyEmailChangeNew",
        params,
      ),
    verifyEmailChangeStepUp: (params: AccountVerifyEmailChangeStepUpParams) =>
      invokeAction<AccountVerifyEmailChangeStepUpResponse>(
        "account",
        "verifyEmailChangeStepUp",
        params,
      ),
  },
  notifications: {
    createClubNotification: (
      params: NotificationsCreateClubNotificationParams,
    ) =>
      invokeAction<NotificationsCreateClubNotificationResponse>(
        "notifications",
        "createClubNotification",
        params,
      ),
    sendTournamentThankYou: (
      params: NotificationsSendTournamentThankYouParams,
    ) =>
      invokeAction<NotificationsSendTournamentThankYouResponse>(
        "notifications",
        "sendTournamentThankYou",
        params,
      ),
  },
  funding: {
    queueBulkFundingOutreachEmail: (
      params: FundingQueueBulkFundingOutreachEmailParams,
    ) =>
      invokeAction<FundingQueueBulkFundingOutreachEmailResponse>(
        "funding",
        "queueBulkFundingOutreachEmail",
        params,
      ),
    sendFundingOutreachEmail: (params: FundingSendFundingOutreachEmailParams) =>
      invokeAction<FundingSendFundingOutreachEmailResponse>(
        "funding",
        "sendFundingOutreachEmail",
        params,
      ),
    sendPendingFundingOutreachEmail: (
      params: FundingSendPendingFundingOutreachEmailParams,
    ) =>
      invokeAction<FundingSendPendingFundingOutreachEmailResponse>(
        "funding",
        "sendPendingFundingOutreachEmail",
        params,
      ),
    analyzeFundingCommunication: (
      params: FundingAnalyzeFundingCommunicationParams,
    ) =>
      invokeAction<FundingAnalyzeFundingCommunicationResponse>(
        "funding",
        "analyzeFundingCommunication",
        params,
      ),
    startFunderEnrichment: (params: FundingStartFunderEnrichmentParams) =>
      invokeAction<FundingStartFunderEnrichmentResponse>(
        "funding",
        "startFunderEnrichment",
        params,
      ),
    startFundingScoutRun: (params: FundingStartFundingScoutRunParams) =>
      invokeAction<FundingStartFundingScoutRunResponse>(
        "funding",
        "startFundingScoutRun",
        params,
      ),
  },
  session: {
    adoptSession: (params: SessionAdoptSessionParams) =>
      invokeAction<SessionAdoptSessionResponse>(
        "session",
        "adopt-session",
        params,
      ),
    createSession: (params: SessionCreateSessionParams) =>
      invokeAction<SessionCreateSessionResponse>(
        "session",
        "create-session",
        params,
      ),
  },
} as const;
